import axios from 'axios'
import { push } from 'react-router-redux'
import { put, call, take, fork, select } from 'redux-saga/effects'
import { ACCESS_TOKEN, CLIENT, UID } from '../../commons/Const'
import { removeStorage, getStorage } from '../../commons/utils'

const editorStore = state => state.editor

import {
  FETCH_PROJECT,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_FAILURE,
  UPDATE_PROJECT_STARTED,
  UPDATE_PROJECT_STARTED_SUCCESS,
  UPDATE_PROJECT_STARTED_FAILURE,
  RESET_PROJECT,
  RESET_PROJECT_SUCCESS,
  RESET_PROJECT_FAILURE,
  UPDATE_QUESTION_TYPE,
  UPDATE_QUESTION_TYPE_SUCCESS,
  UPDATE_QUESTION_TYPE_FAILURE,
  UPDATE_CHOICE_IMAGE,
  UPDATE_CHOICE_IMAGE_FAILURE,
  UPDATE_CHOICE_IMAGE_SUCCESS,
  DELETE_CHOICE_IMAGE,
  DELETE_CHOICE_IMAGE_FAILURE,
  DELETE_CHOICE_IMAGE_SUCCESS,
  CREATE_QUESTION,
  CREATE_QUESTION_SUCCESS,
  CREATE_QUESTION_FAILURE,
  DELETE_QUESTION,
  DELETE_QUESTION_SUCCESS,
  DELETE_QUESTION_FAILURE,
  UPDATE_EVENT_IMAGE,
  UPDATE_EVENT_IMAGE_SUCCESS,
  UPDATE_EVENT_IMAGE_FAILURE,
  UPDATE_ALL_QUESTIONS,
  UPDATE_ALL_QUESTIONS_SUCCESS,
  UPDATE_ALL_QUESTIONS_FAILURE,
  LOG_OUT,
  LOG_OUT_FAILURE,
  LOG_OUT_SUCCESS,
  FINISH_LOADING,
  CHANGE_RANKING_CONFIG,
  CHANGE_RANKING_CONFIG_SUCCESS,
  GET_IS_FETCHABLE_RANKING_DATA,
  GET_IS_FETCHABLE_RANKING_DATA_FAILURE,
  GET_IS_FETCHABLE_RANKING_DATA_SUCCESS,
  GET_RANKING_DATA,
  GET_RANKING_DATA_FAILURE,
  GET_RANKING_DATA_SUCCESS
} from '../actions/editorActions'

const selectTargetKey = (updateKey, question) => {
  const selectedQuestion = {}
  updateKey.map(key => {
    selectedQuestion[key] = question[key]
  })
  return selectedQuestion
}

//一括更新用のデータを作る
const getNowStateForUpdate = (project_title, presentation_title, ranking_count, questions) => {
  const nowState = {}
  nowState.project_title = project_title
  nowState.presentation_title = presentation_title
  nowState.ranking_count = ranking_count
  // questions内で必要なもののみ追加する
  const updateKey = ['id', 'title', 'limit_time', 'answer_choice_id', 'index']
  nowState.questions = questions.map(question => ({
    ...selectTargetKey(updateKey, question),
    choices: question.choices.map(choice => ({
      id: choice.id,
      title: choice.title
    }))
  }))
  return nowState
}

// editorStateの中身を一時的にupdateする
const updateInfoState = (updateKey, updateValue, editor) => {
  const newState = {}
  for (let key in editor) {
    if (key === updateKey) {
      newState[key] = updateValue
    } else {
      newState[key] = editor[key]
    }
  }
  return newState
}

//////////////////////
//// fetchProject ////
//////////////////////

export function* runFetchProjectHandler() {
  while (true) {
    yield take([`${FETCH_PROJECT}`])
    yield fork(fetchProjectHandler)
  }
}

function* fetchProjectHandler() {
  // 会員登録していないとすぐにわかる場合はリダイレクト
  if (!getStorage(ACCESS_TOKEN) || !getStorage(CLIENT) || !getStorage(UID)) {
    yield put(push('/login'))
    return
  }

  const payload = yield call(fetchProject)

  if (payload.data) {
    yield put(FETCH_PROJECT_SUCCESS(payload.data))
    return
  } else if (payload.error && payload.error.code === 'error.unauthonized') {
    yield put(push('/login'))
    return
  }
  yield put(FETCH_PROJECT_FAILURE(payload.error.message))
}

const fetchProject = async () => {
  return await axios.get('/api/v1/organizers/projects').catch(error => ({ error: error.response.data }))
}

//////////////////////////////
//// updateProjectStarted ////
//////////////////////////////

export function* runUpdateProjectStartedHandler() {
  while (true) {
    const { payload } = yield take([`${UPDATE_PROJECT_STARTED}`])
    yield fork(updateProjectStartedHandler, payload)
  }
}

function* updateProjectStartedHandler(payload) {
  const { error } = yield call(updateProjectStarted, payload)

  if (error) {
    yield put(UPDATE_PROJECT_STARTED_FAILURE(error.message))
    return
  }
  yield put(UPDATE_PROJECT_STARTED_SUCCESS(payload.started))
}

const updateProjectStarted = async params => {
  return await axios
    .patch('/api/v1/organizers/projects/started', {
      started: params.started
    })
    .catch(error => ({ error: error.response.data }))
}

//////////////////////
//// resetProject ////
//////////////////////

export function* runResetProjectHandler() {
  while (true) {
    yield take([`${RESET_PROJECT}`])
    yield fork(resetProjectHandler)
  }
}

function* resetProjectHandler() {
  const { error } = yield call(resetProject)

  if (error) {
    yield put(RESET_PROJECT_FAILURE(error.message))
    return
  }
  yield put(RESET_PROJECT_SUCCESS())
  window.open('presentation', 'presentation', 'width=960,height=720')
}

const resetProject = async () => {
  return await axios.post('/api/v1/organizers/projects/reset').catch(error => ({ error: error.response.data }))
}

//////////////////////
//// questionType ////
//////////////////////

export function* runUpdateQuestionTypeHandler() {
  while (true) {
    const { payload } = yield take([`${UPDATE_QUESTION_TYPE}`])
    const editor = yield select(editorStore)
    yield fork(putUpdateQuestionTypeHandler, payload, editor)
  }
}

function* putUpdateQuestionTypeHandler(payload, editor) {
  const { data, error } = yield call(putQuestionType, payload, editor)
  if (error != null) {
    yield put(UPDATE_QUESTION_TYPE_FAILURE(error.message))
    return
  }
  yield put(UPDATE_QUESTION_TYPE_SUCCESS(data))
}

const putQuestionType = async (data, editor) => {
  const params = updateInfoState('question_type', Number(data), editor.project.questions[editor.currentEditIndex])
  return await axios
    .put(
      `/api/v1/organizers/projects/${editor.project.id}/questions/${
        editor.project.questions[editor.currentEditIndex].id
      }`,
      params
    )
    .catch(error => ({ error: error.response.data }))
}

//////////////////////
/// choiceImage //////
//////////////////////

export function* runUpdateChoiceImageHandler() {
  while (true) {
    const { payload } = yield take([`${UPDATE_CHOICE_IMAGE}`])
    const editor = yield select(editorStore)
    yield fork(putUpdateChoiceImageHandler, payload, editor)
  }
}

function* putUpdateChoiceImageHandler(payload, editor) {
  const { data, error } = yield call(putChoiceImage, payload, editor)
  if (error != null) {
    yield put(UPDATE_CHOICE_IMAGE_FAILURE(error.message))
    return
  }
  yield put(UPDATE_CHOICE_IMAGE_SUCCESS(data))
}

const putChoiceImage = async (data, editor) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  const formData = new FormData()
  formData.append('image', data.targetImage)
  return await axios
    .put(
      `/api/v1/organizers/projects/${editor.project.id}/questions/${
        editor.project.questions[editor.currentEditIndex].id
      }/choices/${editor.project.questions[editor.currentEditIndex].choices[data.targetKey].id}`,
      formData,
      config
    )
    .catch(error => ({ error: error.response.data }))
}

////////////////////
///  deleteImage ///
////////////////////

export function* runDeleteChoiceImageHandler() {
  while (true) {
    const { payload } = yield take([`${DELETE_CHOICE_IMAGE}`])
    const editor = yield select(editorStore)
    yield fork(putDeleteChoiceImageHandler, payload, editor)
  }
}

function* putDeleteChoiceImageHandler(payload, editor) {
  const { error } = yield call(deleteChoiceImage, payload, editor)
  if (error != null) {
    yield put(DELETE_CHOICE_IMAGE_FAILURE(error.message))
    return
  }
  yield put(DELETE_CHOICE_IMAGE_SUCCESS(payload))
}

const deleteChoiceImage = async (data, editor) => {
  return await axios
    .delete(
      `/api/v1/organizers/projects/${editor.project.id}/questions/${
        editor.project.questions[editor.currentEditIndex].id
      }/choices/${editor.project.questions[editor.currentEditIndex].choices[data.targetKey].id}`
    )
    .catch(error => ({
      error: error.response.data
    }))
}

//////////////////////
/// createQuestion ///
//////////////////////
export function* runCreateQuestionHandler() {
  while (true) {
    const { payload } = yield take([`${CREATE_QUESTION}`])
    yield fork(createQuestionHandler, payload)
  }
}
function* createQuestionHandler(payload) {
  const { data, error } = yield call(createQuestion, payload)
  if (error != null) {
    yield put(CREATE_QUESTION_FAILURE(error.message))
    return
  }
  yield put(CREATE_QUESTION_SUCCESS(data))
}
const createQuestion = async payload => {
  return await axios
    .post(`/api/v1/organizers/projects/${payload.projectId}/questions/`, {
      index: payload.newIndex
    })
    .catch(error => ({ error: error.response.data }))
}

//////////////////////
/// changeRanking  ///
//////////////////////
const confirmParticipants = async payload => {
  const res = await axios.get(`/api/v1/organizers/projects/${payload.projectId}/participants/exists`)
  return res.data
}

export function* runChangeRankingHandler() {
  while (true) {
    const { payload } = yield take([`${CHANGE_RANKING_CONFIG}`])
    yield fork(changeRankingHandler, payload)
  }
}

function* changeRankingHandler(payload) {
  const data = yield call(confirmParticipants, payload)
  if (data.is_exists) {
    alert(
      '参加者がいるため変更できません。問題を削除する場合は、クイズを一度再生して参加者のデータをリセットしてください。'
    )
    yield put(FINISH_LOADING())
    return
  }

  yield put(CHANGE_RANKING_CONFIG_SUCCESS(payload))
}

//////////////////////
/// deleteQuestion ///
//////////////////////
export function* runDeleteQuestionHandler() {
  while (true) {
    const { payload } = yield take([`${DELETE_QUESTION}`])
    yield fork(deleteQuestionHandler, payload)
  }
}
function* deleteQuestionHandler(payload) {
  const data = yield call(confirmParticipants, payload)
  if (data.is_exists) {
    alert(
      '参加者がいるため削除できません。問題を削除する場合は、クイズを一度再生して参加者のデータをリセットしてください。'
    )
    yield put(FINISH_LOADING())
    return
  }

  const { error } = yield call(deleteQuestion, payload)
  if (error != null) {
    yield put(DELETE_QUESTION_FAILURE(error.data))
    return
  }
  yield put(DELETE_QUESTION_SUCCESS({ questionId: payload.questionId }))
}
const deleteQuestion = async payload => {
  return await axios
    .delete(`/api/v1/organizers/projects/${payload.projectId}/questions/${payload.questionId}`)
    .catch(error => ({ error: error.response.data }))
}

/////////////////////
/// eventImage //////
/////////////////////

export function* runUpdateEventImageHandler() {
  while (true) {
    const { payload } = yield take([`${UPDATE_EVENT_IMAGE}`])
    const editor = yield select(editorStore)
    yield fork(putUpdateEventImageHandler, payload, editor)
  }
}

function* putUpdateEventImageHandler(payload, editor) {
  const { data, error } = yield call(putEventImage, payload, editor)
  if (error != null) {
    yield put(UPDATE_EVENT_IMAGE_FAILURE(error.data))
    return
  }
  yield put(UPDATE_EVENT_IMAGE_SUCCESS(data))
}

const putEventImage = async (data, editor) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  const formData = new FormData()
  formData.append('image', data.targetImage)
  return await axios
    .patch(`/api/v1/organizers/projects/${editor.project.id}/image`, formData, config)
    .catch(error => ({ error: error.response.data }))
}

//////////////////////////
/// updateAllQuestions ///
//////////////////////////

export function* runUpdateAllQuestionsHandler() {
  while (true) {
    const { payload } = yield take([`${UPDATE_ALL_QUESTIONS}`])
    const editor = yield select(editorStore)
    yield fork(putUpdateAllQuestionsHandler, payload, editor)
  }
}

function* putUpdateAllQuestionsHandler(payload, editor) {
  const { data, error } = yield call(putUpdateQuestions, payload, editor)
  if (error != null) {
    yield put(UPDATE_ALL_QUESTIONS_FAILURE(error))
    return
  }
  yield put(UPDATE_ALL_QUESTIONS_SUCCESS(data))
}

const putUpdateQuestions = async (data, editor) => {
  // 今のstateを取得して、エンドポイントの形式に合うようにして送る
  const nowState = getNowStateForUpdate(
    editor.project.project_title,
    editor.project.presentation_title,
    editor.project.ranking_count,
    editor.project.questions
  )
  return await axios
    .put(`/api/v1/organizers/projects/${editor.project.id}`, nowState)
    .catch(error => ({ error: error.response.data }))
}

//////////////
/// logOut ///
//////////////

export function* runLogOutHandler() {
  while (true) {
    yield take([`${LOG_OUT}`])
    yield fork(logOutHandler)
  }
}

const removeAuthInfo = () => {
  removeStorage(UID)
  removeStorage(CLIENT)
  removeStorage(ACCESS_TOKEN)
}

function* logOutHandler() {
  const { error } = yield call(logOut)
  // エラーを無視してlocalStorageから情報を削除する
  removeAuthInfo()
  if (error != null) {
    yield put(LOG_OUT_FAILURE(error))
    return
  }
  yield put(LOG_OUT_SUCCESS())
}

const logOut = async () => {
  return await axios.delete('/api/v1/organizers/auth/sign_out').catch(error => ({ error: error.response.data }))
}

/////////////////////////////////////
/// get_is_fetchable_ranking_data ///
/////////////////////////////////////

export function* runGetIsFetchableRankingDataHandler() {
  while (true) {
    const { payload } = yield take([`${GET_IS_FETCHABLE_RANKING_DATA}`])
    yield fork(getIsFetchableRankingDataHandler, payload)
  }
}

function* getIsFetchableRankingDataHandler(payload) {
  const { data, error } = yield call(getIsFetchableRankingData, payload)
  if (error != null) {
    yield put(GET_IS_FETCHABLE_RANKING_DATA_FAILURE(error))
    return
  }
  yield put(GET_IS_FETCHABLE_RANKING_DATA_SUCCESS(data))
}

const getIsFetchableRankingData = async payload => {
  return await axios
    .get(`/api/v1/organizers/projects/${payload.projectId}/ranking/check`)
    .catch(error => ({ error: error.response.data }))
}

////////////////////////
/// get_ranking_data ///
////////////////////////

export function* runGetRankingDataHandler() {
  while (true) {
    const { payload } = yield take([`${GET_RANKING_DATA}`])
    yield fork(getRankingDataHandler, payload)
  }
}

function* getRankingDataHandler(payload) {
  const { data, error } = yield call(getRankingData, payload)
  if (error != null) {
    yield put(GET_RANKING_DATA_FAILURE(error))
    return
  }
  yield put(GET_RANKING_DATA_SUCCESS(data))
}

const getRankingData = async payload => {
  const rankingData = await axios
    .get(`/api/v1/organizers/projects/${payload.projectId}/ranking/completed`)
    .catch(error => ({ error: error.response.data }))

  if (rankingData.error) {
    return { error: rankingData.error }
  }
  const blob = new Blob([rankingData.data], {
    type: 'text/csv;charset=utf-8;'
  })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'ranking.csv'
  link.click()

  URL.revokeObjectURL(url)
  return { data: 'csv download success' }
}
